import { RouteSegment } from '@global/enums/route-segment.enum';

export const profilePictureFallback = 'assets/images/profile-picture-fallback.png';
export const defaultStoreFeePercentage = 30;
export const navMenuItems = [
  {
    link: [RouteSegment.Dashboard],
    exact: true,
    icon: 'dashboard',
    title: 'NAVIGATION.DASHBOARD',
  },
  {
    link: [RouteSegment.QuoteList],
    exact: false,
    icon: 'quote-new',
    title: 'NAVIGATION.QUOTES',
  },
  {
    link: [RouteSegment.ShipmentsList],
    exact: false,
    icon: 'list',
    title: 'NAVIGATION.SHIPMENTS',
  },
  {
    link: [RouteSegment.Tracking],
    exact: true,
    icon: 'plane-take-off',
    title: 'NAVIGATION.TRACKING',
  },
  {
    link: [RouteSegment.Invoices],
    exact: true,
    icon: 'quotes',
    title: 'NAVIGATION.INVOICES',
  },
  {
    link: [RouteSegment.Insights],
    exact: true,
    icon: 'insights',
    title: 'NAVIGATION.INSIGHTS',
  },
  {
    link: [RouteSegment.Messages],
    exact: true,
    icon: 'messages',
    title: 'NAVIGATION.MESSAGES',
  },
];
